import {AEntity} from "~/models/abstract/AEntity";

export interface ITag {
    tagLib: string,
    tagLibLong: string | null,
    tagColorType?: string,
}

export class Tag extends AEntity {
    tagLib: string
    tagLibLong: string | null
    tagColorType?: string

    constructor(tag: ITag) {
        super();
        this.tagLib = tag.tagLib
        this.tagLibLong = tag.tagLibLong
        this.tagColorType = tag.tagColorType
    }

    override getId(): string {
        return `${this.tagLib}`
    }

    override toJSON(): ITag {
        return {
            tagLib: this.tagLib,
            tagLibLong: this.tagLibLong,
            tagColorType: this.tagColorType,
        }
    }
}
